@if (loaderShown) {
    <div class="notification-overlay">
        <div class="loader" [style.backgroundImage]="loaderImageUrl"> </div>
    </div>
}
